import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {Typography, alpha} from "@mui/material";

import Bs4FormElement from './Bs4FormElement';
import Bs4MainDispatch from '../Bs4MainDispatch';

import { useDroppable, useDraggable } from '@dnd-kit/core';
import { shallowEqual } from '../Bs4Components/Bs4Utils'; 

export default class Bs4Partition extends Bs4FormElement {
  constructor(props) {
    super(props);
  }

  formElementType = 3;

  ConstructorModeMenu = (props) => {
    const formPartition = this;

    const handleEdit = () => {
      const details = {currFormId: formPartition.props.partition.formId, targetObject: formPartition.props.partition.formId, targetOption: 298}; 
      Bs4MainDispatch.commandParser('Bs4OpenCard', details, this.bs4KartotekaId);
      props.closeMenu()
    }    

    const handleMenuClose = () => {
      props.closeMenu()
    }

    const handleClickPartition = (e) => {
      // console.log('...Szpalta...', this.props.partition);
      props.closeMenu()
    }

    return (
      <Menu anchorEl={props.anchorEl} open={props.open} onClose={handleMenuClose}>
        <MenuItem>
          <Typography variant='h6' onClick={handleClickPartition}>{'Szpalta'}</Typography>
        </MenuItem>
        {formPartition.props.partition.formId ?
          <MenuItem onClick={handleEdit}>
            <ListItemIcon><i className="fas fa-cog"></i></ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>      
        : null}                
      </Menu>
    )
  }

  ViewConstructorMode = (props) => {
    if (!this.props.bs4ConstructorMode.enabled || this.props.criterion) return null;
    const formPartition = this;
    const theme = useTheme();
    const [anchorElMenu, setAnchorElMenu] = React.useState(null);
    const [select, setSelect] = React.useState(false);
    const {activeCurrent} = React.useContext(this.bs4Form.activeCurrentContext);
    
    const bgcolorMoveSection = React.useMemo(() => {
      return alpha(theme.palette.secondary.main, 0.4);
    });

    const handleGearMenu = (event) => {
      setAnchorElMenu(event.currentTarget);
    }    

    const closeMenu = () => {
      setAnchorElMenu(null);
      setSelect(false);
    }

    const handleSelect = (e) => {
      setSelect(e.type === 'mouseenter' || Boolean(anchorElMenu));
    }

    const showGear = props.showGear || Boolean(anchorElMenu) || activeCurrent?.formElement?.formElementType === this.formElementType;

    const {listeners, setActivatorNodeRef} = props.draggable 

    const sxGrill = React.useMemo(() => {
      let gril = this.getGrilleBox(activeCurrent?.formElement === this ? 2 : 1);
      const display = (select || activeCurrent?.formElement === this || (activeCurrent?.formElement?.formElementType === this.formElementType))
      return {
        display: display ? 'block' : 'none',
        ...gril
      }      
    }) 

    return (
      <React.Fragment>
        <Box sx={{position:'absolute', top:0, right:0, bottom: 0, left: 0, ...sxGrill}}/>
        <IconButton
          tabIndex={-1}
          sx={{position:'absolute', top:-5, left:-5, display: showGear ? 'block' : 'none'}}
          onClick={handleGearMenu}
          onMouseEnter={handleSelect}
          onMouseLeave={handleSelect}
        >
          <i className="fa-solid fa-gear-code"></i>
        </IconButton>
        {/* <IconButton 
          ref={setActivatorNodeRef} 
          tabIndex={-1}
          {...listeners}
          sx={{position:'absolute', top:-5, left: 20, display: showGear ? 'block' : 'none'}}
          onMouseEnter={handleSelect}
          onMouseLeave={handleSelect}
        >
          <i className="fa-solid fa-arrows-up-down-left-right"></i>
        </IconButton> */}
        
        <formPartition.ConstructorModeMenu open={Boolean(anchorElMenu)} anchorEl={anchorElMenu} closeMenu={closeMenu}/>
      </React.Fragment>
    )
  }  

  ViewComponent = React.memo((props) => { 
    const formPartition = this;
    const collapsible = this.formElementArray.length > 1;	
    const length = this.formElementArray.length;
    const [showGear, setShowGear] = React.useState(false);
    const refFocusInOut = React.useRef();
  
    const droppable = useDroppable({
      id: this.getElementId('Droppable'),
      data: {
        formElement: this,
        type: 'form',
      },
      disabled: !this.props.bs4ConstructorMode.enabled,
    });    

    const draggable = useDraggable({
      id: this.getElementId('Draggable'),
      data: {
        formElement: this,
        type: 'form',
      },
      disabled: !this.props.bs4ConstructorMode.enabled,
    });

    const {isOver, setNodeRefDroppable} = React.useMemo(() => {
      return { isOver: droppable.isOver, setNodeRefDroppable: droppable.setNodeRef }
    }, [droppable])

    const {attributes, listeners, setNodeRef, setActivatorNodeRef, transform, node} = draggable

    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });    
    
    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
        collapsible,
        length,
        showGear,
        droppable,
      };
      const sv = shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues');
      const sp = shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps');
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), Boolean(this.props.criterion) ? 'CR' : this.props?.formId , sv, sp,);
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, '..Partition..');    

    const handleShowGear = React.useCallback((e) => {
      if (!this.props.bs4ConstructorMode.enabled) return null;
      //const willShowGear = e.type === 'mouseenter' ? true : false;
      setShowGear(e.type === 'mouseenter')
    }, [setShowGear]);

    React.useEffect(() => {               
      this.getFormElementSize = () => {
        if (props.size) return props.size;
        if (refFocusInOut.current) {
          const rect = refFocusInOut.current.getBoundingClientRect();
          return {
            width: rect.width,
            height: rect.height,
          }
        }
      }
    }, []);

    const width = props.size ? props.size.width : { xs: '100%', sm: '100%', md: '100%', lg: formPartition.props.partition.width};
    const justifyContent = React.useMemo(() => {
      switch (formPartition.props?.partition?.justifyContent || 'left') {
        case 'center': return 'center'
        case 'right': return 'flex-end'
        case 'left':
        default: return 'flex-start'
      }
    }, [formPartition.props?.partition?.justifyContent]);    

    if (formPartition.bs4flexframe) return (
      <Box
        ref={node => {
          refFocusInOut.current = node;
          setNodeRef(node);
          setNodeRefDroppable(node)
        }}        
        id={formPartition.getElementId()}
        position={'relative'}
        overflow='hidden'
        width={width}
        height='100%'
        display='flex'
        flexDirection={'column'}
        justifyContent={justifyContent}
        onMouseEnter={handleShowGear}
        onMouseLeave={handleShowGear}  
      >
        {formPartition.formElementArray.map((section, index) => {
          section.collapsible = section?.props?.collapsible && collapsible;
          section.collapsed = section?.props?.collapsed && collapsible;
          return <section.ViewComponent {...props} key={section.inputId} sectionStart={index === 0} sectionEnd={index === length - 1}/>
        })}
        <formPartition.ViewConstructorMode showGear={showGear} draggable={draggable}/>    
      </Box>
    );    

    return (      
      <Stack   
        ref={node => {
          refFocusInOut.current = node;
          setNodeRef(node);
          setNodeRefDroppable(node)
        }}     
        id={formPartition.getElementId()}   
        position={'relative'} 
        overflow='hidden'
        direction="row"  
        justifyContent="flex-start"  
        flexWrap={'wrap'} 
        spacing={0} 
        width={width}
        onMouseEnter={handleShowGear}
        onMouseLeave={handleShowGear}  
      >
      {formPartition.formElementArray.map((section, index) => {
        section.collapsible = section?.props?.collapsible && collapsible;
        section.collapsed = section?.props?.collapsed && collapsible;
        return <section.ViewComponent {...props} key={section.inputId} sectionStart={index === 0} sectionEnd={index === length - 1}/>
      })}
      <formPartition.ViewConstructorMode showGear={showGear} draggable={draggable}/>
      </Stack>      
    );
  });
}